import { render } from "./AssignmentTable.vue?vue&type=template&id=c69f0ed8&scoped=true&ts=true"
import script from "./AssignmentTable.ts?vue&type=script&lang=ts"
export * from "./AssignmentTable.ts?vue&type=script&lang=ts"

import "./AssignmentTable.scss?vue&type=style&index=0&id=c69f0ed8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69f0ed8"]])

export default __exports__